import React from 'react';
import { Box, Typography } from '@mui/material';
import Barcode from 'react-barcode';
import type { BarcodeFormat } from '../../../utils/barcodeFormatTranslator';

type TicketCardBarcodeProps = {
  barcodeValue: string | null;
  barcodeFormat?: BarcodeFormat;
  displayValue: string;
  isSoldOut: boolean;
  metaText: string;
  unavailableMessage: string;
};

const TicketCardBarcode: React.FC<TicketCardBarcodeProps> = React.memo(({
  barcodeValue,
  barcodeFormat,
  displayValue,
  isSoldOut,
  metaText,
  unavailableMessage,
}) => {
  return (
    <Box className="barcode">
      <Box className="barcodeInner">
        {isSoldOut ? (
          <Typography variant="h6" className="sold-out">
            SOLD OUT
          </Typography>
        ) : barcodeValue && barcodeFormat ? (
          <Barcode
            value={barcodeValue}
            format={barcodeFormat}
            width={3}
            height={80}
            displayValue={false}
            margin={2}
            lineColor="#000000"
            background="#ffffff"
            textAlign="center"
            fontSize={12}
            fontOptions="bold"
          />
        ) : (
          <Typography variant="caption" color="error">
            {unavailableMessage}
          </Typography>
        )}
      </Box>
      {!isSoldOut && (
        <>
          <Typography variant="body2" className="number">
            {displayValue}
          </Typography>
          <Typography variant="caption" className="barcodeMeta">
            {metaText}
          </Typography>
        </>
      )}
    </Box>
  );
});

TicketCardBarcode.displayName = 'TicketCardBarcode';

export default TicketCardBarcode;
